import { useNavigate } from 'react-router-dom';

const LoginForm = ({
  email,
  setEmail,
  password,
  setPassword,
  handleLogin,
  loading,
  errorMessage
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div style={styles.formContainer}>
      <p style={styles.notice}>※ このページは <strong>管理者専用</strong> です</p>

      {/* 🔽 目立つ位置に移動 */}
      <button onClick={handleBack} style={styles.backButton}>
        👈 トップに戻る
      </button>

      <label htmlFor="email">メールアドレス</label>
      <input
        id="email"
        type="email"
        placeholder="メールアドレス"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
        disabled={loading}
        aria-label="メールアドレス"
        autoComplete="email"
      />

      <label htmlFor="password">パスワード</label>
      <input
        id="password"
        type="password"
        placeholder="パスワード"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={styles.input}
        disabled={loading}
        aria-label="パスワード"
        autoComplete="current-password"
      />

      {errorMessage && (
        <p style={styles.errorMessage}>{errorMessage}</p>
      )}

      <button
        onClick={handleLogin}
        style={{
          ...styles.button,
          ...(loading ? styles.buttonDisabled : {})
        }}
        disabled={loading}
      >
        {loading ? "ログイン中..." : "ログイン"}
      </button>
    </div>
  );
};

const styles = {
  formContainer: {
    textAlign: 'center',
    marginTop: '30px',
    padding: '0 16px',
    maxWidth: '400px',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  notice: {
    color: '#666',
    marginBottom: '12px',
    fontSize: '14px',
  },
  backButton: {
    marginBottom: '24px',
    backgroundColor: '#e91e63',
    color: '#fff',
    padding: '10px',
    fontSize: '15px',
    fontWeight: 'bold',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  },
  input: {
    marginTop: '10px',
    marginBottom: '16px',
    padding: '12px',
    width: '100%',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    boxSizing: 'border-box',
  },
  button: {
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '12px',
    fontSize: '16px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    transition: 'background-color 0.3s ease',
  },
  buttonDisabled: {
    backgroundColor: '#9E9E9E',
    cursor: 'not-allowed',
  },
  errorMessage: {
    color: '#e91e63',
    fontSize: '14px',
    marginBottom: '16px',
  },
};

export default LoginForm;
